export { namespace } from './actions';
import { ACTION_TYPES, Status } from './actions';

const initialState = {
  status: Status.INITIAL,
  currentUploadFile: {},
  playoutData: [],
  totalRecords: 0,
  userSetting: {
    status: Status.INITIAL,
    isSchemaHelperClosed: true,
    map: {}
  },
  currentErrorFile: {
    status: Status.INITIAL
  }
}

export default function playoutReducer(state = initialState, action) {

  switch (action.type) {
    case ACTION_TYPES.SET_CURRENT_UPLOAD_FILE_REF:
      {
        const { file = null, uploadType = '' } = action.payload;
        return {
          ...state,
          currentUploadFile: {
            ...state.currentUploadFile,
            ref: file,
            uploadType: parseInt(uploadType)
          }
        }
      }
    case ACTION_TYPES.SET_LOADING_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          status
        }
      }
    case ACTION_TYPES.SET_PLAYOUT_OVERVIEW:
      {
        const { overviewList, range, totalRecords } = action.payload;
        return {
          ...state,
          status: Status.LOADED,
          playoutData: overviewList,
          range: range || state.range,
          totalRecords: totalRecords || state.totalRecords
        }
      }
    case ACTION_TYPES.SET_PLAYOUT_DATA_SETTING:
      {
        const { isSchemaHelperClosed, map = {} } = action.payload.settings;
        return {
          ...state,
          userSetting: {
            status: Status.LOADED,
            isSchemaHelperClosed,
            map: {
              ...state.userSetting.map,
              ...map
            }
          }
        }
      }

      case ACTION_TYPES.UPDATE_CURRENT_UPLOAD_DATA:
        {
          const { data } = action.payload;
          return {
            ...state,
            currentUploadFile: {
              ...state.currentUploadFile,
              ...data
            }
          }
        }
      
      case ACTION_TYPES.SAVE_SINGED_URI_PLAYOUT_ERROR: 
        {
          const { uri } = action.payload;
          return {
            ...state,
            currentErrorFile: {
              ...state.currentErrorFile,
              uri: uri           
            }
          }
        }

      case ACTION_TYPES.SET_LOADING_PLAYOUT_ERROR_STATUS:
        {
          const { status } = action.payload;
          return {
            ...state,
            currentErrorFile: {
              ...state.currentErrorFile,
              status
            }
          }
        }
    default:
      return state;
  }
}
